import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, FormProps, Modal, ModalProps, Spin, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import candidatesService from '../../services/candidates.service';
import { CandidateType } from '../../types/candidate-type';
import { notifyError } from '../../utils/notification';
import { TAInput } from '../widgets';

interface IAddReportFormModal {
	isAcpc?: boolean;
	candidateId: string;
	onAdd: (data: any) => void;
	onCancel: () => void;
}

export const AddReportFormModal: React.FC<FormProps & ModalProps & IAddReportFormModal> = ({
	candidateId,
	visible,
	onCancel,
	onAdd,
	isAcpc
}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState<boolean>(false);
	const [newReport, setNewReport] = useState({ name: null, technicalReport: null });

	useEffect(() => {
		setNewReport({ name: null, technicalReport: null });
		form.resetFields();
	}, [candidateId]);

	const handleChange = input => {
		if (input.target?.value) setNewReport({ ...newReport, name: input.target.value });
		else if (input.file) setNewReport({ ...newReport, technicalReport: input.file });
	};

	const onFinish = async values => {
		setLoading(true);
		const fd = new FormData();
		Object.keys(values).forEach(key => {
			fd.append(key, values[key]);
		});
		let response;

		try {
			response = await candidatesService.addCustomReport(
				candidateId,
				fd,
				isAcpc ? CandidateType.ACPC : CandidateType.TALENTS_ARENA
			);
			if (!response) throw new Error('something went wrong');
		} catch (error) {
			notifyError("Couldn't add a new report, try again later");
			return;
		} finally {
			setLoading(false);
		}
		onAdd(response.data);
		onCancel();

		form.resetFields();
		setNewReport({ name: null, technicalReport: null });
	};

	return (
		<Modal
			title="Add new report"
			visible={visible}
			onCancel={onCancel}
			onOk={form.submit}
			okText="Add"
			className="ta-modal"
			okButtonProps={{ loading }}
		>
			<Spin spinning={loading}>
				<Form layout="vertical" className="ta-form" onFinish={onFinish}>
					<Form.Item
						label="Report name"
						name="reportName"
						rules={[{ required: true, message: 'You must enter the technical report name' }]}
					>
						<TAInput type="text" placeholder="Enter the technical report name" onChange={handleChange} />
					</Form.Item>
					<Form.Item
						label="Report"
						name="reportFile"
						rules={[{ required: true, message: 'You must upload the technical report' }]}
					>
						<Upload
							name="Technical Report"
							beforeUpload={() => false}
							onChange={handleChange}
							accept=".pdf,.docx,.doc,.txt"
							fileList={newReport.name && newReport.technicalReport ? [newReport.technicalReport] : []}
						>
							<Button>
								<UploadOutlined />
								Upload
							</Button>
						</Upload>
					</Form.Item>
				</Form>
			</Spin>
		</Modal>
	);
};

export default AddReportFormModal;
